import { render, staticRenderFns } from "./Sandflox.vue?vue&type=template&id=3708da9e&scoped=true&"
import script from "./Sandflox.vue?vue&type=script&lang=ts&"
export * from "./Sandflox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3708da9e",
  null
  
)

export default component.exports